export const UserType = {
  USER: "USER",
  ADVERTISER: "ADVERTISER",
  CREATOR: "CREATOR",
};
